import { get, post } from '@/request/racmBlockRequest';

export function getDictDetail(dictType) {
  return get('system/dict/data/type/' + dictType);
}

export function imageUpload(params) {
  return post('/common/uploads', params);
}
